



















import { Component, Prop, Vue } from "vue-property-decorator";
// import { getPlural } from "@/plugins/strings";
@Component
export default class PrecheckLoader extends Vue {
    @Prop(Boolean) isLoading;
    @Prop({ default: () => 0 }) time: number;
    // get minutes() {
    //     return Math.floor(this.time / 60);
    // }
    // get seconds() {
    //     return this.time % 60;
    // }
    // get timeString(): string {
    //     let res = "";
    //     const plur = (val: number) => getPlural(val, "а", "ы", "");
    //     if (this.minutes) res += `${this.minutes} минут${plur(this.minutes)} `;
    //     res += `${this.seconds} секунд${plur(this.seconds)}`;
    //     return res;
    // }
}
